import React from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface SubscriptionFAQProps {
  faqs?: FAQItem[];
}

const defaultFAQs: FAQItem[] = [
  {
    question: 'What is included in a subscription?',
    answer: 'A Legal Nest Premium subscription gives you access to exclusive content, case analyses, and premium features depending on your subscription tier.'
  },
  {
    question: 'Can I change plans later?',
    answer: 'Yes, you can upgrade or downgrade your subscription plan at any time. Changes will take effect in your next billing cycle.'
  },
  {
    question: 'How do I cancel my subscription?',
    answer: 'You can cancel your subscription at any time from your account settings. Your subscription benefits will remain active until the end of your current billing period.'
  },
  {
    question: 'Is there a refund policy?',
    answer: 'We offer a 7-day money-back guarantee for new subscribers. Contact our support team for assistance with refunds.'
  }
];

const SubscriptionFAQ: React.FC<SubscriptionFAQProps> = ({ faqs = defaultFAQs }) => {
  return (
    <div className="max-w-3xl mx-auto">
      <h2 className="text-2xl font-serif font-bold mb-6 text-center">Frequently Asked Questions</h2>
      
      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-white p-6 rounded-lg border border-neutral-200">
            <h3 className="font-bold mb-2">{faq.question}</h3>
            <p className="text-neutral-600">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionFAQ;